import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { loginRedirectState } from "@/utils/auth";
import { PropsWithChildren } from "react";

export default function RequireAuth({ children }: PropsWithChildren) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div
          data-testid="loading-spinner"
          className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"
        />
      </div>
    );
  }

  if (!user) {
    // Save the current location to redirect back after login.
    return (
      <Navigate
        to="/login"
        state={loginRedirectState(location)}
        replace
      />
    );
  }

  return <>{children}</>;
}
